/**
 * Column options for enum-typed columns.
 */
export interface ColumnEnumOptions {

    /**
     * Array of possible enumerated values.
     */
    enum?: any[]|Object;

}